import { SAGA_REQUEST_KEY } from 'Constants';
import financialTypes from './types';

export const initialStates = {
	balance: null,
	balance_details: null,
	verify_payment: null,
	payment_request: null,
	payment_history_list: null,
	payment_details: [],
	transactions: [],
	inquiry_sheba: {},
	inquiry_sheba_loading: false,
};

const financialReducers = (state = initialStates, action) => {
	switch (action.type) {
		case financialTypes.BALANCE.SUCCESS: {
			return { ...state, balance: action?.payload?.amount_detail };
		}

		case financialTypes.BALANCE_DETAILS.SUCCESS: {
			return { ...state, balance_details: action?.payload?.data };
		}

		case financialTypes.VERIFY_PAYMENT.SUCCESS: {
			return { ...state, verify_payment: action?.payload };
		}
		case financialTypes.PAYMENT_REQUEST.SUCCESS: {
			return { ...state, payment_request: action?.payload };
		}

		case financialTypes.PAYMENT_HISTORY_LIST.SUCCESS: {
			let key =
				action?.payload?.requestAction?.[SAGA_REQUEST_KEY.LOADING_ID] ||
				'payment_history_list';
			return { ...state, [key]: action?.payload?.response };
		}

		case financialTypes.PAYMENT_REQUEST_DETAILS.SUCCESS: {
			return { ...state, payment_details: action.payload?.data };
		}

		case financialTypes.TRANSACTIONS.SUCCESS: {
			return { ...state, transactions: action.payload?.data };
		}

		case financialTypes.INQUIRY_SHEBA.REQUEST: {
			return { ...state, inquiry_sheba_loading: true, inquiry_sheba: null };
		}
		case financialTypes.INQUIRY_SHEBA.SUCCESS: {
			return {
				...state,
				inquiry_sheba_loading: false,
				inquiry_sheba: action.payload?.data,
			};
		}
		case financialTypes.INQUIRY_SHEBA.FAILURE: {
			return { ...state, inquiry_sheba_loading: false };
		}

		default:
			return state;
	}
};

export default financialReducers;
